import { Checkbox, FormControlLabel } from '@material-ui/core';
import React, { Component } from 'react';

class NewAgainField extends Component {

    render() {
        return (
            <FormControlLabel
                value="newAgain"
                control={<Checkbox color="primary" checked={this.props.checked} onChange={this.props.onChange} />}
                label="Még egy"
                labelPlacement="start"
                className="another-checkbox"
            />
        )
    }
}
export default NewAgainField;